/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Review_LocaleInputs */

const cs_property_ai_review_locale = /** @type {(inputs: Property_Ai_Review_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazyk ke kontrole`)
};

const en_property_ai_review_locale = /** @type {(inputs: Property_Ai_Review_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language to mark reviewed`)
};

/**
* | output |
* | --- |
* | "Language to mark reviewed" |
*
* @param {Property_Ai_Review_LocaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_review_locale = /** @type {((inputs?: Property_Ai_Review_LocaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Review_LocaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_review_locale(inputs)
	return cs_property_ai_review_locale(inputs)
});